import { useEffect, useRef, useState } from 'react';

export default function CTA() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );
    const el = sectionRef.current;
    if (el) observer.observe(el);
    return () => { if (el) observer.unobserve(el); };
  }, []);

  const handleContact = () => {
    window.REACT_APP_NAVIGATE('/contact');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section
      ref={sectionRef}
      className="w-full py-20 md:py-28 bg-white"
    >
      <div
        className={`max-w-[860px] mx-auto px-6 md:px-12 text-center transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        {/* Heading */}
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2C2C2C] mb-5 leading-tight">
          Ready to Protect Your Rights?
        </h2>

        {/* Subtext */}
        <p className="text-base md:text-lg text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed">
          Schedule a free consultation with our experienced legal team today. We&apos;re here to listen, advise, and fight for your best interests.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-10">
          <button
            onClick={handleContact}
            className="w-full sm:w-auto px-8 py-3 md:py-4 bg-gradient-to-r from-[#6A1B9A] to-[#9C27B0] text-white rounded-full font-bold text-sm md:text-base hover:opacity-90 transition-opacity duration-200 cursor-pointer whitespace-nowrap"
          >
            Schedule Consultation
          </button>
          <a
            href="tel:0795808857"
            className="w-full sm:w-auto px-8 py-3 md:py-4 bg-white text-[#6A1B9A] border-2 border-[#6A1B9A] rounded-full font-bold text-sm md:text-base hover:bg-[#6A1B9A] hover:text-white transition-colors duration-200 cursor-pointer whitespace-nowrap text-center"
          >
            <i className="ri-phone-line mr-2"></i>
            Call Now
          </a>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200 mb-8" />

        {/* Contact Details Row */}
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 justify-center items-center text-sm text-gray-500">
          <div className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line text-gray-400 text-base"></i>
            </div>
            <span>079 580 8857</span>
          </div>
          <div className="hidden sm:block w-px h-4 bg-gray-300" />
          <div className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-mail-line text-gray-400 text-base"></i>
            </div>
            <span>info@mohubapartners.co.za</span>
          </div>
          <div className="hidden sm:block w-px h-4 bg-gray-300" />
          <div className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-map-pin-line text-gray-400 text-base"></i>
            </div>
            <span>Polokwane, Limpopo</span>
          </div>
        </div>
      </div>
    </section>
  );
}
